import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/waitlist-boilerplate/content.tsx");
